import { useMemo } from 'react'
import { useSpotSwapUserTradeStatus } from '~/state/dex/hooks'
import { SpotSwapUserTradeStatus } from '~/state/dex/type'
import IconNormal from '~/assets/images/mascot-normal.gif'
import IconEyesDown from '~/assets/images/mascot-eyes-down.gif'
import IconEcstatic from '~/assets/images/mascot-ecstatic.gif'
import IconLonging from '~/assets/images/mascot-longing.gif'
import IconUpset from '~/assets/images/mascot-upset.gif'
import styled from 'styled-components'

const InteractiveMascot: React.FC = () => {
  const status = useSpotSwapUserTradeStatus()
  const Icon = useMemo(() => {
    switch (status) {
      case SpotSwapUserTradeStatus.NORMAL:
        return IconNormal
      case SpotSwapUserTradeStatus.INQUIRING:
        return IconEyesDown
      case SpotSwapUserTradeStatus.PREVIEWING_ORDER:
        return IconLonging
      case SpotSwapUserTradeStatus.ORDER_IN_PROGRESS:
        return IconLonging
      case SpotSwapUserTradeStatus.ORDER_COMPLETED:
        return IconEcstatic
      case SpotSwapUserTradeStatus.ORDER_FAILED:
        return IconUpset
      default:
        return IconNormal // 默认图标
    }
  }, [status])

  return (
    <StyledContainer>
      <StyledIconsWrapper>
        <StyledIcon src={Icon.src} alt="mascot" />
      </StyledIconsWrapper>
    </StyledContainer>
  )
}

export default InteractiveMascot

const StyledContainer = styled.div`
  position: absolute;
  top: -69px;
  right: 22px;
  width: 80px;
  height: 80px;
  z-index: 100;
`

const StyledIconsWrapper = styled.div`
  position: relative;
`

const StyledIcon = styled.img`
  width: 100%;
  height: 100%;
`
